import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PROMOTE_AMOUNT_BUTTONS_SIMPLIFIED_EXPERIMENT = defineFcm(
	'promote_amount_buttons_simplified_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experimentName: { type: 'string', optional: true },
				countryCode: { type: 'string' },
				baseAmounts: { type: 'array', shape: { type: 'number' } },
				preSelectedBaseAmount: { type: 'number', optional: true },
				experimentAmounts: { type: 'array', shape: { type: 'number' } },
				preSelectedExperimentAmount: { type: 'number', optional: true },
			},
		}),
	)
	.withDefault({
		experimentName: undefined,
		countryCode: 'US',
		baseAmounts: [3, 10, 25, 50, 100, 250],
		preSelectedBaseAmount: 3,
		experimentAmounts: [5, 25, 50, 100, 250, 500],
		preSelectedExperimentAmount: undefined,
	})
	.toConfig({
		owner: 'squad-koi',
		scope: 'corgi-front-end',
		context: 'promote',
		description: 'Controls the simplified layout experiment for amount buttons on the promote page',
		template: {
			experimentName: '',
			baseAmounts: [3, 10, 25, 50, 100, 250],
			preSelectedBaseAmount: 3,
			experimentAmounts: [5, 25, 50, 100, 250, 500],
			preSelectedExperimentAmount: undefined,
			countryCode: 'US',
		},
		import: false,
	});
